import { closeAccountReasonMapping, } from '../models/b2c/close-account';
import { pushEventInfo, setPageDetails, setPageErrorInfo } from './analytics';
export var setCloseAccountViewPageAnalytics = function () {
    var page = {
        category: {
            primaryCategory: 'account',
            subCategory1: 'account>profile',
            subCategory2: 'account>profile>close account',
        },
        pageInfo: {
            pageName: 'account>profile>close account',
            pageType: 'maml:profile',
        },
    };
    setPageDetails(page);
};
export var setCloseAccountPageLinksAnalytics = function (linkName) {
    var thdAnalyticsEvent = {
        category: {
            primaryCategory: 'stash',
        },
        eventInfo: {
            eventName: 'my account settings',
        },
        eventMode: 'stash',
        myAccount: {
            settings: "close account: ".concat(linkName),
        },
    };
    pushEventInfo(thdAnalyticsEvent);
};
export var setCloseAccountCancelLinkAnalytics = function () {
    var thdAnalyticsEvent = {
        category: {
            primaryCategory: 'button submission',
        },
        eventInfo: {
            eventName: 'my account settings',
        },
        myAccount: {
            settings: 'close account: cancel',
        },
    };
    pushEventInfo(thdAnalyticsEvent);
};
export var setCloseAccountSuccessAnalytics = function (reason) {
    var thdAnalyticsEvent = {
        category: {
            primaryCategory: 'button submission',
        },
        eventInfo: {
            eventName: 'my account settings',
        },
        myAccount: {
            settings: "close account: closed: ".concat(closeAccountReasonMapping[reason]),
        },
    };
    pushEventInfo(thdAnalyticsEvent);
};
// Errors
export var setCloseAccountPostPageLoadAPIErrorAnalytics = function (genericApiError) {
    setPageErrorInfo('system', 'page', 'close account page form', "api error: ".concat(genericApiError.toLowerCase()), 'n/a');
};
export var setCloseAccountPostPageLoadErrorAnalytics = function (errorMessage) {
    var thdAnalyticsEvent = {
        category: {
            primaryCategory: 'error',
        },
        eventInfo: {
            eventName: 'post page error',
            error: [
                {
                    type: 'error',
                    displayType: 'advisory',
                    pageSection: 'close account page form',
                    message: "".concat(errorMessage.toLowerCase()),
                    code: 'n/a',
                },
            ],
        },
    };
    pushEventInfo(thdAnalyticsEvent);
};
